import { useEventTracker } from '@applyboard/ui-utils';
export var useCefEventTracker = function useCefEventTracker() {
  var _useEventTracker = useEventTracker({
      page: 'CEF'
    }),
    trackEvent = _useEventTracker.trackEvent,
    Track = _useEventTracker.Track;
  return {
    trackEvent: trackEvent,
    Track: Track
  };
};